import React, { useEffect, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./Header.css";
import OffcanvasMenu from "./OffcanvasMenu/OffcanvasMenu";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import logo from "./../.././../logo.jpg";
const Header = () => {
  let location = useLocation();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => (!show ? setShow(true) : setShow(false));

  const [navBar, setnavBar] = useState(false);
  const listenScrollEvent = () => {
    window.scrollY > 10 ? setnavBar(true) : setnavBar(false);
  };
  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  }, []);

  return (
    <>
      <nav
        className={
          show
            ? "navbar fixed-top open white pe-0"
            : navBar
            ? "navbar fixed-top navbar-is-fixed"
            : location?.pathname === "/login" ||
              location?.pathname === "/register" || location?.pathname === "/platform/apps"
            ? "navbar fixed-top logo-color white"
            : "navbar fixed-top"
        }
        style={{
          transition: "all 0.5s",
        }}
      >
        <div className="container align-content-center mx-lg-auto navbar-brand-container header-image">
          <Link
            className="navbar-brand mr-auto js-sr-intro-3a page-logo blue"
            to="/"
            data-sr-id="6"
            onClick={() => handleClose(false)}
          >
          <img src={logo} alt="" />
          </Link>

          <ul
            className={
              show ? "navbar-nav flex-row open" : "navbar-nav flex-row"
            }
            role="menubar"
            aria-label="Top"
          >
            <li
              className="nav-item d-lg-none js-sr-intro-3a-1-1"
              role="none"
              data-sr-id="8"
            >
              <a
                href="/who-we-are/contact-us/"
                className="contact-icon blue"
                role="menuitem"
                aria-label="Contact Us"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                >
                  <defs>
                    <path
                      id="5hz6cwzhha"
                      d="M10.116.001c5.384 0 9.748 4.332 9.748 9.675 0 5.339-4.364 9.67-9.748 9.67-1.71 0-3.317-.436-4.714-1.2L.005 19.86l1.76-5.191c-.889-1.458-1.4-3.167-1.4-4.993 0-5.343 4.367-9.675 9.75-9.675zm0 1.54c-4.52 0-8.196 3.649-8.196 8.135 0 1.777.579 3.424 1.56 4.768l-1.022 3.019 3.147-1c1.294.847 2.845 1.344 4.51 1.344 4.52 0 8.197-3.649 8.197-8.13 0-4.487-3.678-8.136-8.196-8.136zM7.45 4.638c.274-.168.54-.158.692-.116.154.042.303.105.436.142.135.037.348.013.413.523.068.51.22 1.762.247 1.893.027.13.028.271-.091.404-.119.131-.183.219-.336.32-.153.103-.322.23-.456.304-.145.083-.3.174-.23.439.073.266.332 1.14.849 1.935.666 1.022 1.344 1.466 1.542 1.644.199.177.339.195.516.079.176-.113.758-.51.975-.697.214-.187.36-.104.55.03.08.056.296.239.536.446l.292.254c.24.21.459.404.542.478.198.177.337.275.369.385.032.112-.093.57-.435 1.05-.338.482-1.42.738-1.853.66-.433-.076-.517.229-2.609-1.332-2.09-1.558-2.915-4.345-2.989-4.531-.073-.184-.598-1.498-.29-2.621S7.175 4.81 7.45 4.638z"
                    ></path>
                  </defs>
                  <g fill="none" fill-rule="evenodd">
                    <g>
                      <mask id="vqp2ai5vsb" fill="#fff"></mask>
                      <use
                        fill="#002D5B"
                        fill-rule="nonzero"
                        style={{ mixBlendMode: "multiply" }}
                      ></use>
                      <g fill-rule="nonzero" mask="url(#vqp2ai5vsb)">
                        <g>
                          <path d="M10.116.001c5.384 0 9.748 4.332 9.748 9.675 0 5.339-4.364 9.67-9.748 9.67-1.71 0-3.317-.436-4.714-1.2L.005 19.86l1.76-5.191c-.889-1.458-1.4-3.167-1.4-4.993 0-5.343 4.367-9.675 9.75-9.675zm0 1.54c-4.52 0-8.196 3.649-8.196 8.135 0 1.777.579 3.424 1.56 4.768l-1.022 3.019 3.147-1c1.294.847 2.845 1.344 4.51 1.344 4.52 0 8.197-3.649 8.197-8.13 0-4.487-3.678-8.136-8.196-8.136zM7.45 4.638c.274-.168.54-.158.692-.116.154.042.303.105.436.142.135.037.348.013.413.523.068.51.22 1.762.247 1.893.027.13.028.271-.091.404-.119.131-.183.219-.336.32-.153.103-.322.23-.456.304-.145.083-.3.174-.23.439.073.266.332 1.14.849 1.935.666 1.022 1.344 1.466 1.542 1.644.199.177.339.195.516.079.176-.113.758-.51.975-.697.214-.187.36-.104.55.03.08.056.296.239.536.446l.292.254c.24.21.459.404.542.478.198.177.337.275.369.385.032.112-.093.57-.435 1.05-.338.482-1.42.738-1.853.66-.433-.076-.517.229-2.609-1.332-2.09-1.558-2.915-4.345-2.989-4.531-.073-.184-.598-1.498-.29-2.621S7.175 4.81 7.45 4.638z"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </li>

            <li className="nav-item js-sr-intro-3a-2" role="none">
              <button
                className="nav-link js-menu-open hamburger-icon blue"
                aria-label="Toggle navigation"
                href="#"
                onClick={handleShow}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="20"
                  viewBox="0 0 30 20"
                >
                  <g fill="none" fill-rule="evenodd">
                    <g fill="#002D5B">
                      <rect
                        width="30"
                        height="3"
                        rx="1.5"
                        className="line-1"
                      ></rect>
                      <rect
                        width="30"
                        height="3"
                        y="8.5"
                        rx="1.5"
                        className="line-2"
                      ></rect>
                      <rect
                        width="30"
                        height="3"
                        y="17"
                        rx="1.5"
                        className="line-3"
                      ></rect>
                    </g>
                  </g>
                </svg>
              </button>
            </li>
          </ul>
        </div>
      </nav>

      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        backdrop="static"
        className="offcanvas-menu-area"
      >
        <Offcanvas.Body>
          <OffcanvasMenu handleClose={handleClose} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Header;
